/** Account vs Brand content-stack paths (IA Option A + A1). */

export type KbContentScope = {
  accountId: string;
  /** When set, paths are under BrandHub stack; otherwise enterprise / account stack. */
  brandId?: string | null;
  /** When set with brandId, paths are under a single brand site's materials stack. */
  brandSiteId?: string | null;
};

export function contentStackBase({ accountId, brandId }: KbContentScope): string {
  if (brandId) return `/accounts/${accountId}/brands/${brandId}`;
  return `/accounts/${accountId}`;
}

export function kbWorkbenchPath(scope: KbContentScope): string {
  return `${contentStackBase(scope)}/kb`;
}

export function kbInboxPath(scope: KbContentScope): string {
  return `${contentStackBase(scope)}/inbox`;
}

export function kbMaterialsPath(scope: KbContentScope): string {
  if (scope.brandId && scope.brandSiteId) {
    return `/accounts/${scope.accountId}/brands/${scope.brandId}/sites/${scope.brandSiteId}/materials`;
  }
  return `${contentStackBase(scope)}/materials`;
}

/** Brand-only ops plan (execution calendar / timeline). */
export function brandOpsPlanPath(scope: { accountId: string; brandId: string }): string {
  return `/accounts/${scope.accountId}/brands/${scope.brandId}/plan`;
}

export function kbAuditPath(accountId: string): string {
  return `/accounts/${accountId}/kb/audit`;
}

export function kbPagePath(scope: KbContentScope, wikiId: number, pageId: number): string {
  return `${kbWorkbenchPath(scope)}/wikis/${wikiId}/pages/${pageId}`;
}

/** True when pathname is under brand content stack (kb / materials / inbox / plan / brand_site list), not product apps. */
export function isBrandContentPath(pathname: string): boolean {
  // 站点素材库挂在 AI 官网产品面板，不算品牌内容栈
  return /^\/accounts\/[^/]+\/brands\/[^/]+\/(kb|materials|inbox|plan|brand_site)(\/|$)/.test(
    pathname,
  );
}

/** Parse brandId from brand content or brand hub paths. */
export function brandIdFromPath(pathname: string): string | null {
  const match = pathname.match(/^\/accounts\/[^/]+\/brands\/([^/]+)(?:\/|$)/);
  if (!match) return null;
  const id = match[1];
  if (id === "new" || id === "manage") return null;
  return id;
}
